import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
.ant-popover-inner-content {
    padding: 0px;
}

.listing-map-popover.ant-popover {
    padding-top: 0;
}

.listing-map-popover .ant-popover-inner {
    border-radius: 18px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.04);
}

.listing-map-popover .ant-popover-inner-content {
    padding: 0;
}

.listing-map-popover .ant-popover-arrow {
    display: none;
}

.ant-checkbox > .ant-checkbox-inner {
    border-width: 1px;
    border-radius: 2px;
}

::selection {
  color: inherit;
  background-color: #ACCEF790;
}
`;
